import { useRef } from "react"
import type { RefObject } from "react"
import { flushSync } from "react-dom"
import { useReactToPrint } from "react-to-print"

import { WORK_ORDER_PRINT_PAGE_STYLE } from "../constants"

interface UseWorkOrderPrintResult {
  printViewRef: RefObject<HTMLDivElement>
  printWorkOrder: (mountPrintView: () => void) => void
}

export const useWorkOrderPrint = (documentTitle: string): UseWorkOrderPrintResult => {
  const printViewRef = useRef<HTMLDivElement>(null)

  const print = useReactToPrint({
    contentRef: printViewRef,
    documentTitle,
    bodyClass: "root",
    preserveAfterPrint: true,
    pageStyle: WORK_ORDER_PRINT_PAGE_STYLE,
  })

  // The print component is mounted by `mountPrintView`, so it must be flushed to the DOM before printing starts.
  const printWorkOrder = (mountPrintView: () => void) => {
    flushSync(mountPrintView)
    print()
  }

  return { printViewRef, printWorkOrder }
}
